module.exports = __webpack_public_path__ + "static/media/studio2.10f371bb.png";